import React, { useEffect, useState } from "react";
import ParentWrapper from "../../../components/ParentWrapper";
import MetricCards from "./MetricCard";
import GraphCard from "./GraphCard";
import {
  Box, Typography, FormControl, InputLabel, MenuItem, Select,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CommonFilter from "../../../components/CommonFilter";
import Grid from "@mui/material/Grid2";
import { graphData } from "./dashboardGraphData";
import CustomerFrequency from "./charts/CustomerFrequency";
import FrequencyChart from "../dashboard/charts/FrequencyChart";
import DespositionAnalytics from "./charts/DespositionAnalytics";
import CampaignAnalytics from "./charts/CampaignAnalytics";
import AverageHandlingTime from "./charts/AverageHandlingTime";
import AgentAnalytics from "./charts/AgentAnalytics";
import Header from "../../../components/header";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import DashboardMetrics from "../../user/dashboard/DashboardMetrics";
import CallDirection from "./charts/CallDirection";
import Loader from "../../../components/AnimatedLoader";
import { jwtDecode } from "jwt-decode";
import ConversionStatus from "./charts/processBasedSatatusChart";
import CategoryDistribution from "./charts/categoryDistribution";
import { useNavigate } from "react-router-dom";
import ReactECharts from "echarts-for-react";
import { buildSingleTrendGraph } from "./dashboardGraphData";
import AgentReports from "./AgentReports";
import NipponBotDashboard from "../nipponBot/NipponBotDashboard";
import { INTERVIEW_BOT_COMPANY_IDS } from "../nipponBot/constants";


export default function Dashboard2() {
  const [metricDetails, setMetricDetails] = useState({});
  const [cardDetails, setCardDetails] = useState({});
  const [trendDetails, setTrendDetails] = useState({});
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [expandedParams, setExpandedParams] = useState({});
  const [selectedAgentForParam, setSelectedAgentForParam] = useState("");
  const [agentParamTrend, setAgentParamTrend] = useState(null);
  const [payloadData, setPayloadData] = useState();
  const [activeDateRange, setActiveDateRange] = useState({ startDate: "", endDate: "" });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();


  const graphSizes = [
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    { size: 6 },
    // { size: 6 },
  ];

  // getting token from localstorage
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const isInterviewBotCompany = INTERVIEW_BOT_COMPANY_IDS.includes(decodedToken?.companyId);
  const isVtrans =
    decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb06";
  const isTrendOnlyCompany =
    decodedToken?.companyId === "69fdafaff0596b391f8be07b";


  const isFilter = {
    date: true,
    filter: true,
    callDuration: true,
    callScore: false
    // decodedToken?.companyId == "67e560a6ae2e0d3f96b5eb08" || "67e560a6ae2e0d3f96b5eb09" ? true : false,
  };

  useEffect(() => {
    // Build "YYYY-MM-DD" from the browser's LOCAL calendar date, not via
    // toISOString() - that converts to UTC first, so for any timezone ahead
    // of UTC (e.g. IST, UTC+5:30) local midnight on the 1st of the month
    // becomes 18:30 the PREVIOUS day in UTC, silently shifting the default
    // "this month" range (and its first day) back by one calendar day.
    const toLocalDateStr = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const today = new Date();
    const todayStr = toLocalDateStr(today);
    const firstOfMonthStr = toLocalDateStr(new Date(today.getFullYear(), today.getMonth(), 1));

    const activeStart = payloadData?.filters?.startDate || firstOfMonthStr;
    const activeEnd = payloadData?.filters?.endDate || todayStr;
    setActiveDateRange({ startDate: activeStart, endDate: activeEnd });

    const data = {
      startDate: activeStart,
      endDate: activeEnd,
      agentName:
        payloadData?.filters?.agents?.length > 0
          ? payloadData?.filters?.agents
          : [],
      sentiment:
        payloadData?.filters?.sentiment?.length > 0
          ? payloadData?.filters?.sentiment
          : [],
      campaign:
        payloadData?.filters?.campaigns?.length > 0
          ? payloadData?.filters?.campaigns
          : [],
      callDurationText:
        payloadData?.filters?.callDuration?.length > 0
          ? payloadData?.filters?.callDuration
          : [],
      callDirection: payloadData?.filters?.callInteraction
        ? payloadData?.filters?.callInteraction
        : "",
      conversionStatus:
        payloadData?.filters?.conversionStatus?.length > 0
          ? payloadData?.filters?.conversionStatus
          : [],
      categoryDistribution:
        payloadData?.filters?.categoryDistribution?.length > 0
          ? payloadData?.filters?.categoryDistribution
          : [],
      disposition:
        payloadData?.filters?.disposition?.length > 0
          ? payloadData?.filters?.disposition
          : [],
      subDisposition:
        payloadData?.filters?.subDisposition?.length > 0
          ? payloadData?.filters?.subDisposition
          : [],
      callScore:
        payloadData?.filters?.callScore?.length > 0
          ? payloadData?.filters?.callScore
          : [],
    };

    // Nippon Bot companies render an entirely separate dashboard (NipponBotDashboard,
    // returned below before any of this generic data is used) - skip the fetch so we
    // don't fire two unused POSTs on every load/filter change for that company type.
    if (!isInterviewBotCompany) {
      fetchDashboardDetails(data);
    }
  }, [payloadData, isInterviewBotCompany]);

  useEffect(() => {
    const agentRows = trendDetails?.agentTrend || [];
    const languageRows = trendDetails?.languageTrend || [];

    if (agentRows.length > 0) {
      const nextAgentId = agentRows.some(item => String(item?.agentId) === String(selectedAgentId))
        ? selectedAgentId
        : String(agentRows[0]?.agentId || "");
      setSelectedAgentId(nextAgentId);
    } else {
      setSelectedAgentId("");
    }

    if (languageRows.length > 0) {
      const nextLanguage = languageRows.some(item => String(item?.language) === String(selectedLanguage))
        ? selectedLanguage
        : String(languageRows[0]?.language || "");
      setSelectedLanguage(nextLanguage);
    } else {
      setSelectedLanguage("");
    }
  }, [trendDetails, selectedAgentId, selectedLanguage]);

  const handleSentimentClick = (sentimentType) => {
    redirectToInteractionList({
      sentiment: [sentimentType], // e.g., ["Positive"]
    });
  };

  // DashboardMetrics cards already build a complete filter object
  // (e.g. { sentiment: ["Positive"], status: "" }), so forward it as-is
  // instead of re-wrapping it like handleSentimentClick does for the chart.
  const handleMetricCardClick = (filterPayload) => {
    redirectToInteractionList(filterPayload || {});
  };

  // Handler for campaign chart clicks
  const handleCampaignClick = (campaignName) => {
    redirectToInteractionList({
      campaigns: [campaignName],
    });
  };

  // Handler for agent analytics clicks
  const handleAgentClick = (agentName) => {
    redirectToInteractionList({
      agents: [agentName],
    });
  };

  // Handler for disposition clicks
  const handleDispositionClick = (dispositionName) => {
    redirectToInteractionList({
      disposition: [dispositionName],
    });
  };

  // Handler for call direction clicks
  const handleCallDirectionClick = (direction) => {
    redirectToInteractionList({
      callInteraction: direction, // "Inbound" or "Outbound"
    });
  };

  // Handler for conversion status clicks
  const handleConversionStatusClick = (status) => {
    redirectToInteractionList({
      conversionStatus: [status], // e.g., ["Converted"]
    });
  };

  // Handler for category distribution clicks
  const handleCategoryClick = (category) => {
    redirectToInteractionList({
      categoryDistribution: [category], // e.g., ["Agent"]
    });
  };

  const fetchParameterTrendByAgent = async (agentId) => {
    try {
      const trendEndpoint = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2"
        ? apiEndPointsConfig?.kiwiInteractionTrendAnalytics
        : apiEndPointsConfig?.interactionTrendAnalytics;
      const result = await axiosInstance.post(
        trendEndpoint,
        { companyId: decodedToken?.companyId, agentId: agentId || "" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAgentParamTrend(result?.data?.data?.parameterTrend ?? null);
    } catch (error) {
      console.error("Error fetching parameter trend by agent:", error);
    }
  };

  const handleAgentForParamChange = (event) => {
    const val = String(event.target.value || "");
    setSelectedAgentForParam(val);
    if (val) {
      fetchParameterTrendByAgent(val);
    } else {
      setAgentParamTrend(null);
    }
  };

  const handleAgentTrendChange = (event) => {
    setSelectedAgentId(String(event.target.value || ""));
  };

  const handleLanguageTrendChange = (event) => {
    setSelectedLanguage(String(event.target.value || ""));
  };

  const agentTrendRows = trendDetails?.agentTrend || [];
  const languageTrendRows = trendDetails?.languageTrend || [];

  const agentTrendOption = buildSingleTrendGraph(trendDetails, "agentTrend", "", selectedAgentId, {
    lineColor: "#7C3AED",
    areaColorTop: "rgba(124, 58, 237, 0.28)",
    areaColorBottom: "rgba(124, 58, 237, 0.05)",
  });
  const languageTrendOption = buildSingleTrendGraph(trendDetails, "languageTrend", "", selectedLanguage, {
    lineColor: "#059669",
    areaColorTop: "rgba(5, 150, 105, 0.28)",
    areaColorBottom: "rgba(5, 150, 105, 0.05)",
  });

  const Sparkline = ({ data, color }) => {
    if (!data || data.length < 2) return <span style={{ color: "#bbb", fontSize: 11 }}>—</span>;
    const values = data.map((d) => d.averageCallScore || 0);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1;
    const W = 80, H = 28;
    const pts = values
      .map((v, i) => {
        const x = (i / (values.length - 1)) * W;
        const y = H - ((v - min) / range) * (H - 4) - 2;
        return `${x.toFixed(1)},${y.toFixed(1)}`;
      })
      .join(" ");
    const tooltipText = data
      .map((d) => `${d.date}: ${(d.averageCallScore || 0).toFixed(1)}%`)
      .join("\n");
    return (
      <svg width={W} height={H} style={{ display: "block" }}>
        <title>{tooltipText}</title>
        <polyline points={pts} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      </svg>
    );
  };

  const TrendBadge = ({ data }) => {
    if (!data || data.length < 2) return null;
    const nonZero = data.filter((d) => (d.totalCalls || 0) > 0);
    if (nonZero.length < 2) return null;
    const first = nonZero[0].averageCallScore || 0;
    const last = nonZero[nonZero.length - 1].averageCallScore || 0;
    const diff = last - first;
    if (diff > 0.05)
      return <span style={{ color: "#16a34a", fontWeight: 700, fontSize: 11, whiteSpace: "nowrap" }}>↑ +{diff.toFixed(1)}%</span>;
    if (diff < -0.05)
      return <span style={{ color: "#dc2626", fontWeight: 700, fontSize: 11, whiteSpace: "nowrap" }}>↓ {diff.toFixed(1)}%</span>;
    return <span style={{ color: "#9ca3af", fontWeight: 700, fontSize: 11 }}>→</span>;
  };

  const toggleParam = (paramName) =>
    setExpandedParams((prev) => ({ ...prev, [paramName]: !prev[paramName] }));

  const renderParameterTable = () => {
    const rows = agentParamTrend ?? trendDetails?.parameterTrend ?? [];

    // Collect every date that has at least one record across all parameters / sub-params
    const allDates = [...new Set(
      rows.flatMap((param) => [
        ...(param.trend || []).filter((d) => (d.totalCalls || 0) > 0).map((d) => d.date),
        ...(param.subParameters || []).flatMap((sub) =>
          (sub.trend || []).filter((d) => (d.totalCalls || 0) > 0).map((d) => d.date)
        ),
      ])
    )].sort();

    const fmtDate = (iso) => {
      const [, mo, dd] = iso.split("-");
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return `${dd} ${months[parseInt(mo, 10) - 1]}`;
    };

    const scoreCell = (trend, date) => {
      const d = trend?.find((t) => t.date === date);
      return d && (d.totalCalls || 0) > 0
        ? (d.averageCallScore || 0).toFixed(2)
        : "—";
    };

    const stickyLeft0 = { position: "sticky", left: 0, zIndex: 2 };
    const stickyLeft44 = { position: "sticky", left: 44, zIndex: 2, minWidth: 220 };

    return (
      <Grid size={{ xs: 12 }}>
        <GraphCard>
          <Box sx={{ width: "100%", minWidth: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 1, mb: 2 }}>
              <Typography fontSize={14} variant="body2" color="#464646" fontWeight={700} sx={{ flex: "1 1 auto", minWidth: 0 }}>
                Parameter &amp; Sub-Parameter Score Trend
              </Typography>
              <FormControl size="small" sx={{ minWidth: { xs: 160, sm: 220 }, flexShrink: 0 }}>
                <InputLabel id="param-agent-label">Select Agent</InputLabel>
                <Select
                  labelId="param-agent-label"
                  value={selectedAgentForParam}
                  label="Select Agent"
                  onChange={handleAgentForParamChange}
                  MenuProps={{ PaperProps: { sx: { zIndex: 1600 } } }}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#7C3AED" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#7C3AED" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#7C3AED" },
                    "& .MuiSelect-select": { color: "#7C3AED", fontWeight: 700 },
                  }}
                >
                  <MenuItem value="">All Agents</MenuItem>
                  {agentTrendRows.map((agent) => (
                    <MenuItem key={agent.agentId} value={agent.agentId}>
                      {agent.agentName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {rows.length === 0 ? (
              <Box display="flex" alignItems="center" justifyContent="center" height={100} color="#999" fontWeight={600} fontSize="1rem">
                No data available
              </Box>
            ) : (
              <TableContainer sx={{ maxHeight: "70vh", overflowY: "auto", overflowX: "auto" }}>
                <Table size="small" stickyHeader sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: 44, fontWeight: 700, bgcolor: "#f9f9f9", ...stickyLeft0 }} />
                      <TableCell sx={{ fontWeight: 700, bgcolor: "#f9f9f9", ...stickyLeft44 }}>
                        Parameter / Sub-Parameter
                      </TableCell>
                      {allDates.map((date) => (
                        <TableCell key={date} align="center" sx={{ fontWeight: 700, bgcolor: "#f9f9f9", minWidth: 72, whiteSpace: "nowrap" }}>
                          {fmtDate(date)}
                        </TableCell>
                      ))}
                      <TableCell sx={{ fontWeight: 700, bgcolor: "#f9f9f9", minWidth: 88 }} align="right">Avg Score</TableCell>
                      <TableCell sx={{ fontWeight: 700, bgcolor: "#f9f9f9", minWidth: 60 }} align="right">Calls</TableCell>
                      <TableCell sx={{ fontWeight: 700, bgcolor: "#f9f9f9", minWidth: 130 }} align="center">Trend</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((param) => {
                      const paramExpanded = !!expandedParams[param.parameter];
                      const hasSubs = param.subParameters?.length > 0;
                      return (
                        <React.Fragment key={param.parameter}>
                          {/* ── Parameter row ── */}
                          <TableRow sx={{ bgcolor: "#fff0f0" }}>
                            <TableCell sx={{ width: 44, bgcolor: "#fff0f0", ...stickyLeft0 }}>
                              <IconButton size="small" onClick={() => toggleParam(param.parameter)}>
                                {paramExpanded ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                              </IconButton>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#DC2626", bgcolor: "#fff0f0", ...stickyLeft44 }}>
                              {param.parameter}
                            </TableCell>
                            {allDates.map((date) => (
                              <TableCell key={date} align="center" sx={{ fontSize: "0.8rem" }}>
                                {scoreCell(param.trend, date)}
                              </TableCell>
                            ))}
                            <TableCell align="right" sx={{ fontWeight: 700 }}>{(param.averageCallScore ?? 0).toFixed(2)}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 600 }}>{param.totalCalls}</TableCell>
                            <TableCell>
                              <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                                <Sparkline data={param.trend} color="#DC2626" />
                                <TrendBadge data={param.trend} />
                              </Box>
                            </TableCell>
                          </TableRow>

                          {/* ── Sub-parameter rows ── */}
                          {paramExpanded &&
                            hasSubs &&
                            param.subParameters.map((sub) => (
                              <TableRow key={`sub-${sub.subParameter}`} sx={{ bgcolor: "#fffbf0" }}>
                                <TableCell sx={{ bgcolor: "#fffbf0", ...stickyLeft0 }} />
                                <TableCell sx={{ pl: 5, fontWeight: 600, color: "#92400e", bgcolor: "#fffbf0", ...stickyLeft44 }}>
                                  ↳ {sub.subParameter}
                                </TableCell>
                                {allDates.map((date) => (
                                  <TableCell key={date} align="center" sx={{ fontSize: "0.8rem" }}>
                                    {scoreCell(sub.trend, date)}
                                  </TableCell>
                                ))}
                                <TableCell align="right">{(sub.averageCallScore ?? 0).toFixed(2)}</TableCell>
                                <TableCell align="right">{sub.totalCalls}</TableCell>
                                <TableCell>
                                  <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                                    <Sparkline data={sub.trend} color="#D97706" />
                                    <TrendBadge data={sub.trend} />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </GraphCard>
      </Grid>
    );
  };

  const renderTrendChartCard = ({
    title,
    selectLabel,
    selectId,
    accentColor,
    rows,
    selectedValue,
    onChange,
    option,
    optionKey,
  }) => {
    const hasData = rows.length > 0;
    const effectiveValue = selectedValue || String(rows[0]?.[optionKey] || "");

    return (
      <GraphCard>
        <Box
          sx={{
            height: { xs: "40vh", md: "50vh" },
            width: "100%",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: 1,
              mb: 2,
            }}
          >
            <Typography
              fontSize={14}
              variant="body2"
              color="#464646"
              fontWeight={700}
              sx={{ flex: "1 1 auto", minWidth: 0 }}
            >
              {title}
            </Typography>
            <FormControl size="small" sx={{ minWidth: { xs: 160, sm: 220 }, flexShrink: 0 }}>
              <InputLabel id={`${selectId}-label`}>{selectLabel}</InputLabel>
              <Select
                labelId={`${selectId}-label`}
                id={`${selectId}-select`}
                value={effectiveValue}
                label={selectLabel}
                onChange={onChange}
                MenuProps={{
                  PaperProps: {
                    sx: { zIndex: 1600 },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: accentColor || "#cfcfcf",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: accentColor || "#cfcfcf",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: accentColor || "#cfcfcf",
                  },
                  "& .MuiSelect-select": {
                    color: accentColor || "#464646",
                    fontWeight: 700,
                  },
                }}
              >
                {rows.map((item) => {
                  const value = String(item?.[optionKey] || "");
                  const label = item?.agentName || item?.language || "Unknown";
                  return (
                    <MenuItem key={value || label} value={value}>
                      {label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>

          {hasData ? (
            <ReactECharts
              option={option}
              style={{ flex: 1 }}
              opts={{ renderer: "svg" }}
            />
          ) : (
            <Box
              flex={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="1rem"
              fontWeight={600}
              color="#999"
              borderRadius="8px"
            >
              No data available
            </Box>
          )}
        </Box>
      </GraphCard>
    );
  };


  const redirectToInteractionList = (extraFilters = {}) => {


    const mergedFilters = {
      ...payloadData?.filters,   // existing filters from dashboard
      ...extraFilters,           // filter from clicked metric
    };
    localStorage.setItem(
      "interactionFilters",
      JSON.stringify(mergedFilters)
    );

    console.log("Navigating with filters:", mergedFilters);

    navigate("/user/audio-details", {
      state: {
        filters: mergedFilters,
      },
    });
  };



  // fetch dashboard details function
  const fetchDashboardDetails = async (data) => {
    try {
      const dashboardEndpoint = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2"
        ? apiEndPointsConfig?.kiwiDashboard
        : apiEndPointsConfig?.dashboard;
      const trendEndpoint = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2"
        ? apiEndPointsConfig?.kiwiInteractionTrendAnalytics
        : apiEndPointsConfig?.interactionTrendAnalytics;
      const [dashboardResult, trendResult] = await Promise.allSettled([
        axiosInstance.post(dashboardEndpoint, data, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axiosInstance.post(
          trendEndpoint,
          {
            companyId: decodedToken?.companyId,
            startDate: data.startDate,
            endDate: data.endDate,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        ),
      ]);

      if (dashboardResult.status === "fulfilled") {
        setCardDetails(dashboardResult?.value?.data?.data || {});
      } else {
        const statusCode = dashboardResult?.reason?.response?.data?.status?.code;
        if (statusCode === 401) {
          localStorage.clear();
        } else {
          console.error("Error while fetching dashboard details :", dashboardResult?.reason);
        }
      }

      if (trendResult.status === "fulfilled") {
        setTrendDetails(trendResult?.value?.data?.data || {});
      } else {
        const statusCode = trendResult?.reason?.response?.data?.status?.code;
        if (statusCode === 401) {
          localStorage.clear();
        } else {
          console.error("Error while fetching trend details :", trendResult?.reason);
        }
        setTrendDetails({});
      }

      setLoading(false);
    } catch (error) {
      console.error("Error while fetching dashboard details :", error);
      setLoading(false);
    }
  };

  if (isTrendOnlyCompany) {
    return (
      <>
        {loading ? (
          <ParentWrapper>
            <Loader />
          </ParentWrapper>
        ) : (
          <ParentWrapper sx={{ backgroundColor: "#FFFFFF" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 1 }}>
              <CommonFilter
                setPayloadData={setPayloadData}
                storageName="managerDashboard"
                isFilter={isFilter}
                defaultDateRange="month"
              />
            </Box>

            <DashboardMetrics cardDetails={cardDetails?.sentimentData} onMetricClick={handleMetricCardClick} />

            <Grid container mt={1} spacing={{ xs: 2, md: 4 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                {renderTrendChartCard({
                  title: "Agent Wise Call Score Trend",
                  selectLabel: "Select Agent",
                  selectId: "agent-trend",
                  accentColor: "#7C3AED",
                  rows: agentTrendRows,
                  selectedValue: selectedAgentId,
                  onChange: handleAgentTrendChange,
                  option: agentTrendOption,
                  optionKey: "agentId",
                })}
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                {renderTrendChartCard({
                  title: "Language Wise Call Score Trend",
                  selectLabel: "Select Language",
                  selectId: "language-trend",
                  accentColor: "#059669",
                  rows: languageTrendRows,
                  selectedValue: selectedLanguage,
                  onChange: handleLanguageTrendChange,
                  option: languageTrendOption,
                  optionKey: "language",
                })}
              </Grid>
              {renderParameterTable()}
            </Grid>

            <Box mt={4}>
              <AgentReports
                trendDetails={trendDetails}
                startDate={activeDateRange.startDate}
                endDate={activeDateRange.endDate}
                token={token}
                companyId={decodedToken?.companyId}
              />
            </Box>
          </ParentWrapper>
        )}
      </>
    );
  }

  if (isInterviewBotCompany) {
    return <NipponBotDashboard />;
  }

  return (
    <>
      {loading ? (
        <ParentWrapper>
          <Loader />
        </ParentWrapper>
      ) : (
        <ParentWrapper sx={{ backgroundColor: "#FFFFFF" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 1 }}>
            <CommonFilter
              setPayloadData={setPayloadData}
              storageName="managerDashboard"
              isFilter={isFilter}
              defaultDateRange="month"
            />
          </Box>

          <DashboardMetrics cardDetails={cardDetails?.sentimentData} onMetricClick={handleMetricCardClick} />

          <Grid container mt={1} spacing={4}>
            {graphSizes?.map((cfg, i) => {
              if (
                (i === 0 || i === 2) &&
                decodedToken?.companyId !== "67e560a6ae2e0d3f96b5eb08"
              ) {
                return null; // 🔥 no Grid, no space
              }
              if (isVtrans && (i === 3 || i === 8)) {
                return null;
              }
              const option = graphData(cardDetails)[i];
              return (
                <Grid key={i} size={{ xs: 12, sm: 12, md: cfg.size }}>
                  {i === 7 && (
                    <GraphCard>
                      <CustomerFrequency cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {i === 3 && (
                    <GraphCard>
                      <CampaignAnalytics cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {i === 4 && (
                    <GraphCard>
                      <AverageHandlingTime cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {i === 5 && (
                    <GraphCard>
                      <AgentAnalytics cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {i === 6 && (
                    <GraphCard>
                      <DespositionAnalytics cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {i === 8 && (
                    <GraphCard>
                      <CallDirection cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08" && i === 2 && (
                    <GraphCard>
                      <ConversionStatus onStatusClick={handleConversionStatusClick} cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08" && i === 0 && (
                    <GraphCard>
                      <CategoryDistribution onCategoryClick={handleCategoryClick} cardDetails={cardDetails} />
                    </GraphCard>
                  )}
                  {[1].includes(i) && (
                    <GraphCard option={option} onMetricClick={handleSentimentClick} cardDetails={cardDetails} />
                  )}
                </Grid>
              );
            })}
          </Grid>

        </ParentWrapper>
      )}
    </>
  );
}
